module.exports = __webpack_public_path__ + "static/media/sf-test-21.9f254a65.mp3";